import { makeStyles } from '@material-ui/core'
import React from 'react'
import { tokens } from './tokens'
import { Container } from './Container'
import whyChooseImg from '../../assets/mechanicaldesign/Why-Choose-us.png'
import { SectionTitle } from './SectionTitle'

const TEAM_LIST = [
    'Mechanical Design Team',
    'PLC ,HMI ,SCADA Team',
    'Hardware design team',
    'PCB Desing Team',
    'Software development team',
    'Test Fixture Assembly Team',
]

const MACHINE_LIST = ['Laser Cutting', 'Laser Marking', 'CNC Routing', 'Tool Room']

const useStyles = makeStyles(() => ({
    section: { padding: '90px 0' },
    grid: {
        display: 'grid',
        gridTemplateColumns: '1.15fr .85fr',
        gap: 60,
        alignItems: 'start',
        '@media (max-width: 1024px)': { gridTemplateColumns: '1fr' },
    },
    title: {
        position: 'relative',
        textAlign: 'left',
        fontFamily: tokens.fontHeading,
        fontSize: 'clamp(1.5rem, 2.4vw, 2.1rem)',
        fontWeight: 700,
        color: tokens.colorBlack,
        margin: '0 0 20px',
        padding: '0 0 18px',
        '&::after': {
            content: '""', position: 'absolute', left: 0, bottom: 0,
            width: 56, height: 4, borderRadius: 2, background: tokens.colorAccentRed,
        },
    },
    p: { color: tokens.colorTextLight, marginBottom: 26, fontFamily: tokens.fontBody ,fontSize: '1rem'},
    h4: { fontSize: '1.2rem', marginBottom: 14, color: tokens.colorBlack, fontFamily: tokens.fontBody, fontWeight: 700 },
    checkList: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '10px 24px',
        marginBottom: 28,
        listStyle: 'none',
        padding: 0,
        fontFamily: tokens.fontBody,
        '@media (max-width: 640px)': { gridTemplateColumns: '1fr' },
        '& li': {
            position: 'relative',
            paddingLeft: 26,
            fontSize: '.93rem',
            color: tokens.colorText,
            '&::before': {
                content: '"\\2713"',
                position: 'absolute',
                left: 0, top: 0,
                color: tokens.colorAccentGreen,
                fontWeight: 700,
            },
        },
    },
    imageWrap: {
        order: 0,
        '@media (max-width: 1024px)': { order: -1 },
        '& img': {
            borderRadius: tokens.radiusLg,
            boxShadow: tokens.shadowLg,
            width: '100%',
            height: 'auto',
        },
    },
}))

export function WhyChoose() {
    const classes = useStyles()
    return (
        <section className={classes.section} id="why-choose">
            <Container className={classes.grid}>
                <div>
                    <SectionTitle variant={'left'}>Why Choose SLS?</SectionTitle>
                    <p className={classes.p}>
                        SLS is your trusted partner for end-to-end PCBA test automation solutions.
                        We specialize in designing and developing customized test systems,
                        including PCB test fixtures and tailored test software, to meet your
                        unique testing requirements. With a focus on quality, reliability,
                        affordability, and innovation, we deliver accurate, efficient, and
                        scalable testing solutions that help improve product quality, reduce
                        testing time, and optimize manufacturing performance.
                    </p>

                    <h4 className={classes.h4}>In House Team for Test Fixture development</h4>
                    <ul className={classes.checkList}>
                        {TEAM_LIST.map((t) => <li key={t}>{t}</li>)}
                    </ul>

                    <h4 className={classes.h4}>In house Machine setup for fixture development</h4>
                    <ul className={classes.checkList}>
                        {MACHINE_LIST.map((t) => <li key={t}>{t}</li>)}
                    </ul>
                </div>
                <div className={classes.imageWrap}>
                    <img src={whyChooseImg} alt="Custom-built PCB test fixture machine" />
                </div>
            </Container>
        </section>
    )
}
